import { render, staticRenderFns } from "./password.vue?vue&type=template&id=27cbc54b&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=27cbc54b&prod&lang=css&"
import style1 from "./password.vue?vue&type=style&index=1&id=27cbc54b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cbc54b",
  null
  
)

export default component.exports